/**
 * Relationship-related strings.
 */
import React from 'react';
import ArticleButton from '../ui/ArticleButton/ArticleButton';

export default {
    d_title: 'Red Flag',

    d_titleCase: 'Red Flags',
    h_titleCase: <div>
        <p>This section lists the red flags associated with this Case.</p>
        <p>The red flags that show here are either generic (show for every Case), or case-type specific (only show for a
            specific set of case types).</p>
        <p>Learn more about red flags in the Documentation.</p>
        <p><ArticleButton label='Red Flags' article='/sections/red-flags/'/></p>
    </div>,

    d_titleLead: 'Red Flags',
    h_titleLead: <div>
        <p>This section lists the red flags associated with this Lead.</p>
        <p>The red flags that show here are either generic (show for every Lead), or case-type specific (only show for a
            specific set of case types).</p>
        <p>Learn more about red flags in the Documentation.</p>
        <p><ArticleButton label='Red Flags' article='/sections/red-flags/'/></p>
    </div>,

    d_redFlags: 'Red Flags',
    h_redFlags: <div>
        <p><b>Red Flags</b> are risk factors that influence your success with converting leads to good, paying clients.
        </p>
        <p>Learn more about red flags in the Documentation.</p>
        <p><ArticleButton label='Red Flags' article='/sections/red-flags/'/></p>
    </div>,

    d_boost: 'Boost the significance of this red flag?',
    h_boost: <div>
        <p>Boosting this flag will double it's relative impact on the risk score.</p>
        <p>For example, if the flag's normal impact is 120%, the risk impact would be 2 x 1.2 = 2.4</p>
    </div>,

    d_flag: 'Flag',
    h_flag: `<div><p>This is the label for the red flag that will show up in the <b>Red Flags</b> section of a Lead or Case.</p><p>This can be as descriptive as necessary for you and your employees to understand the risks associated with the red flag.</p><p>For example, the red flag <b>Argumentative</b> is pretty easy to understand, and does not need additional description.</p><p>On the other hand, you may have an issue with current clients where they get angry and yell at your staff. This is never good, but sometimes the client just needs to vent (perhaps after a judge rules against them).</p><p>In this case, you might want a slightly more descriptive red flag, e.g. <b>Client takes his anger/frustration out on team (and is not just venting).</b></p></div>`,

    d_relatedTo: 'Related To',
    h_relatedTo: `<div><p>Red Flags can be related to a Lead (part of the sales and intake processes), or a Case (after the client has retained you).</p></div>`,

    d_appliesTo: 'Applies To',
    h_appliesTo: `<div><p>If this red flag only pertains to a particular type of case, enter the case type(s) here.</p><p>If this red flag applies to all cases, leave this field blank.</p></div>`,

    d_categories: 'Categories',
    h_categories: `<div><p>Red Flags are generally associated with one or more business risks, defined below. Some Red Flags will be associated with multiple types of risk. </p><ul><li><b>Financial</b>: A risk to your financial stability, e.g. client will not be able or willing to pay their bills. </li><li><b>Malpractice</b>: A risk to your license, e.g. taking a case that you have little experience with. </li><li><b>Resource</b>: A risk to your ability to complete the work due to lack of resources. </li><li><b>Strategic</b>: A risk to your company's strategic goals, e.g. taking on a type of case that you want to stop servicing. </li><li><b>Temperament</b>: A risk based on a client's temperament or condition, e.g. drug usage. </li></ul></div>`,

    d_weight: 'Weight',
    h_weight: `<div><p>This is the relative weight of the red flag, compared to other red flags.</p><p>A relative weight of 100% (the default), means that this red flag is weight more nor less impactful than other red flags. You can view a weight of 100% as "normal".</p><p>If this red flag has a higher impact on your business, you can change the weighting up or down.</p><p>For example, let's say we have an issue with potential new clients (PNCs) that try to get you to reduce your hourly rate before you even have a chance to present your value proposition (why you charge that rate). You know that these PNCs end up being argumentative clients that fight their bills and end up not paying them, or end up filing grievances.</p><p>This red flag is clearly more impactful than other red flags, so we give it a higher weighting. In this case, we could use a weight of 200%. Once we have more data on the impact (using the analytics functions in Outlaw Practice), we can get a more exact weighting.</p></div>`,

    // Messages
    d_multipleFlags: 'Found more than one red flag for type',


};